import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withRouteData } from 'react-static';

import DefaultHeaderLink from './DefaultHeaderLink';
import { scrollToElement } from '../utils/AnchorScroll';
import { GIFT_CARD_PATH } from '../../../constants';

const HeaderLinks = ({ closeMenu, pathWithoutBasename }) => {
  const scrollToPlans = e => {
    if (pathWithoutBasename !== '/') return;
    const plansSection = document.getElementById('plans-section');
    if (!plansSection) return;
    e.preventDefault();
    if (closeMenu) closeMenu();
    scrollToElement(plansSection, { smooth: true });
  };

  return (
    <React.Fragment>
      <DefaultHeaderLink to="/about">
        <FormattedMessage id="header.cta.about" defaultMessage="About" />
      </DefaultHeaderLink>
      <DefaultHeaderLink to="/#plans-section" onClick={scrollToPlans}>
        <FormattedMessage id="header.cta.plans" defaultMessage="Plans" />
      </DefaultHeaderLink>
      <DefaultHeaderLink to={`/${GIFT_CARD_PATH}`}>
        <FormattedMessage id="header.cta.gift-cards" defaultMessage="Gift Cards" />
      </DefaultHeaderLink>
      <DefaultHeaderLink to="/magazine">
        <FormattedMessage id="header.cta.magazine" defaultMessage="Magazine" />
      </DefaultHeaderLink>
      <DefaultHeaderLink to="https://store.idagio.com" openInNewTab>
        <FormattedMessage id="header.cta.store" defaultMessage="Store" />
      </DefaultHeaderLink>
    </React.Fragment>
  );
};

HeaderLinks.propTypes = {
  closeMenu: PropTypes.func,
  pathWithoutBasename: PropTypes.string.isRequired,
};

export default withRouteData(HeaderLinks);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/header/HeaderLinks.js